import { axios } from "../../config/axios";

export const stashboardAPI = {
  /**
   * Delete stashboard header by id
   * @param {number} stashboardHeaderId
   */
  deleteStashboardHeader(stashboardHeaderId) {
    return axios.delete(`/api/v3/stashboard_header_images/${stashboardHeaderId}`).then(resp => resp.data);
  },
  /**
   * Get all stashboard header
   * @returns an array of stashboard
   */
  getStashboardHeaders(){
    return axios.get("/api/v3/stashboard_header_images").then(resp => resp.data.stashboard_header_images);
  },
  /**
   * Patch decrease the priority of a stashboard header
   * @param {number} stashboardHeaderId
   * @returns {object} 
   */
  patchStashboardHeaderDecreasePriority(stashboardHeaderId){
    return axios.patch(`/api/v3/stashboard_header_images/${stashboardHeaderId}/decrease_priority`).then(resp => resp.data)
  },
  /**
   * Patch increase the priority of a stashboard header
   * @param {number} stashboardHeaderId
   * @returns {object}
   */
  patchStashboardHeaderIncreasePriority(stashboardHeaderId){
    return axios.patch(`/api/v3/stashboard_header_images/${stashboardHeaderId}/increase_priority`).then(resp => resp.data)
  },
  /**
   * POST to add a new stashboard header link
   * @param {object} stashboardHeader
   * @returns {object}
   */
  postStashboardHeader(stashboardHeader) {
    const formData = new FormData()

    formData.append("url", stashboardHeader.url);
    formData.append("file", stashboardHeader.attachment);

    return axios.post(`/api/v3/stashboard_header_images`, formData)
                .then((resp) => resp.data);
  }
}